import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';

const ArchitectStudio = {
  id: '32',
  name: 'Architect Studio',
  width: 2,
  height: 3,
  type: BuildingType.COLLECTABLE,
  era: 'minoanEra',
  icon: 'Architect_Studio',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/Architects_Studio',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new ProductionQueue(
      ProductionWorkforce.asFlat(3),
      [
        ProductionCost.asCallbackWithLevel(
          (level) => {
            if (level <= 13) {
              return 2;
            }
            if (level <= 19) {
              return 3;
            }
            if (level <= 26) {
              return 4;
            }
            if (level <= 33) {
              return 5;
            }
            if (level <= 39) {
              return 6;
            }
            return 7;
          }
        ).withCurrency(ProductionCurrency.RESEARCH_POINTS),
      ],
      ProductionDuration.asHourMinutePerLevel([
        [24,  0], [22, 15], [20, 30], [18, 45], [17,  0],
        [15, 15], [13, 30], [11, 45], [10,  0], [ 8,  0],
        [ 7, 48], [ 7, 38], [ 7, 28], [ 7, 20], [ 7, 12],
        [ 7,  4], [ 6, 57], [ 6, 51], [ 6, 45], [ 6, 40],
        [ 6, 34], [ 6, 30], [ 6, 25], [ 6, 21], [ 6, 17],
        [ 6, 13], [ 6,  9], [ 6,  6], [ 6,  3], [ 6,  0],
        [ 5, 57], [ 5, 54], [ 5, 51], [ 5, 49], [ 5, 46],
        [ 5, 44], [ 5, 42], [ 5, 40], [ 5, 37], [ 5, 36],
      ]),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          if (level <= 10) {
            return 25;
          }

          return 26 + ((level - 11) * 2);
        }
      ).withOutput(ProductionOutputType.GEARS),
    ),
  ]),
};

export default ArchitectStudio;
